module.exports = __webpack_public_path__ + "favicon-32x32.png?8a74c9c1da71134f73cce4d8b8958b14";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/favicon-32x32.png
// module id = 188
// module chunks = 0